import store from '../store'

export default [
  {
    path: '/relatorios/producao',
    name: 'relatorios-producao-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getClientes')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de produção',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao'
      )
    }
  },
  {
    path: '/relatorios/producao/lactacao/exibir',
    name: 'relatorios-producao-lactacao-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoLactacao', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de animais em lactação',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/lactacao'
      )
    }
  },
  {
    path: '/relatorios/producao/proteina/exibir',
    name: 'relatorios-producao-proteina-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoProteina', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de proteína',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/proteina'
      )
    }
  },
  {
    path: '/relatorios/producao/gordura/exibir',
    name: 'relatorios-producao-gordura-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoGordura', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de gordura',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/gordura'
      )
    }
  },
  {
    path: '/relatorios/producao/lactose/exibir',
    name: 'relatorios-producao-lactose-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoLactose', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de lactose',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/lactose'
      )
    }
  },
  {
    path: '/relatorios/producao/solido/exibir',
    name: 'relatorios-producao-solido-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoSolido', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de sólidos',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/solido'
      )
    }
  },
  {
    path: '/relatorios/producao/ccs/exibir',
    name: 'relatorios-producao-ccs-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoCCS', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de CCS',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/ccs'
      )
    }
  },
  {
    path: '/relatorios/producao/cpp/exibir',
    name: 'relatorios-producao-cpp-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoCPP', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de CPP',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/cpp'
      )
    }
  },
  {
    path: '/relatorios/producao/esd/exibir',
    name: 'relatorios-producao-esd-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoESD', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório do índice de ESD',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/esd'
      )
    }
  },
  {
    path: '/relatorios/producao/seca/exibir',
    name: 'relatorios-producao-seca-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoSeca', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório das vacas no fim do período de lactação',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/seca'
      )
    }
  },
  {
    path: '/relatorios/producao/media/leite/exibir',
    name: 'relatorios-producao-media-leite-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoMediaLeite', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório da produção média do leite',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/mediaLeite'
      )
    }
  },
  {
    path: '/relatorios/producao/total/estimada/mes/exibir',
    name: 'relatorios-producao-total-estimada-mes-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoTotalEstimadaMes', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório da produção total estimada do mês',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/totalEstimadaMes'
      )
    }
  },
  {
    path: '/relatorios/producao/valor/pago/leite/exibir',
    name: 'relatorios-producao-valor-pago-leite-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoValorPagoLeite', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de valor pago no leite',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/valorPagoLeite'
      )
    }
  },
  {
    path: '/relatorios/producao/custo/alimentacao/litro/exibir',
    name: 'relatorios-producao-custo-alimentacao-litro-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoCustoAlimentacaoLitro', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de custo da alimentação/litro',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/custoAlimentacaoLitro'
      )
    }
  },
  {
    path: '/relatorios/producao/custo/alimentacao/concentrada/lactacao/exibir',
    name: 'relatorios-custo-alimentacao-concentrada-lactacao-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch(
        'getRelatorioProducaoCustoAlimentacaoConcentradaLactacao',
        {
          cliente: Number(cliente),
          inicial,
          final
        }
      )
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title:
        'Relatório de custo da alimentação concentrada das vacas em lactação',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/custoAlimentacaoConcentradaLactacao'
      )
    }
  },
  {
    path: '/relatorios/producao/custo/alimentacao/volumosa/lactacao/exibir',
    name: 'relatorios-custo-alimentacao-volumosa-lactacao-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch(
        'getRelatorioProducaoCustoAlimentacaoVolumosaLactacao',
        {
          cliente: Number(cliente),
          inicial,
          final
        }
      )
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de custo da alimentação volumosa das vacas em lactação',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/custoAlimentacaoVolumosaLactacao'
      )
    }
  },
  {
    path: '/relatorios/producao/receita/estimada/leite/exibir',
    name: 'relatorios-producao-receita-estimada-leite-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoReceitaEstimadaLeite', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de receita estimada do leite',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/receitaEstimadaLeite'
      )
    }
  },
  {
    path: '/relatorios/producao/despesa/estimada/alimentacao/exibir',
    name: 'relatorios-producao-despesa-estimada-alimentacao-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoDespesaEstimadaAlimentacao', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de despesa estimada com alimentação',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/despesaEstimadaAlimentacao'
      )
    }
  },
  {
    path: '/relatorios/producao/sobra/estimada/exibir',
    name: 'relatorios-producao-sobra-estimada-show',
    beforeEnter: async (to, from, next) => {
      const { cliente, inicial, final } = store.getters.variaveis
      await store.dispatch('getCliente', {
        id: Number(cliente)
      })
      await store.dispatch('getRelatorioProducaoSobraEstimada', {
        cliente: Number(cliente),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: false,
      isChart: true,
      title: 'Relatório de sobra estimada',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/producao/filtros/sobraEstimada'
      )
    }
  }
]
